const initialValues = {
  addressId: null,
  locationName: "",
  addressLine1: "",
  addressLine2: "",
  cityId: "",
  stateId: "",
  zipCode: "",
  contactName: "",
  contactPhone: "",
  contactPhoneExtension: "",
  instructionsOrRestrictions: "",
  dayOfWeekRestricted: [],
};

export default initialValues;
